import { Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
import { observer } from 'mobx-react';
import { useMedia, useStore } from 'shared/hooks';

import "./styles.scss"
import { PPDWidgetPieChartGraph } from './components/PPDWidgetPieChartGraph';
import { PPDWidgetPieChartLegend } from './components/PPDWidgetPieChartLegend';
import { IUnitValue, UserDashboardWidgetModel } from 'shared/models';
import { PPDWidgetPieChartModal } from './components/PPDWidgetPieChartModal';

ChartJS.register(ArcElement, Tooltip, Legend);

type Props = {
    widget: UserDashboardWidgetModel,
}

const mode = 'scale' as 'outline' | 'scale'
export const PPDWidgetPieChart  = observer(({widget }: Props) => {

    const store = useStore(() => ({
        activeIndex: null as null | number,
        isOpenModal: false as boolean,
    }));

    const labels = widget.items.map(item => item.name);
    const values = widget.items.map(item => item.value) as IUnitValue[];
    const amountValues = widget.items.map(item => item.value.amount);
    const colors = widget.items.map(item => item.color);

    const { isMobileOrTablet } = useMedia()

    const MAX_ITEMS_DESKTOP = 5
    const MAX_ITEMS_MOBILE = 4

    const maxItems = isMobileOrTablet ? MAX_ITEMS_MOBILE : MAX_ITEMS_DESKTOP;

    const limitedLabels = labels.slice(0, maxItems);
    const limitedValues = values.slice(0, maxItems);
    const limitedColors = colors.slice(0, maxItems);

    return (
        <div className="ppd-widget-pie-chart">
            <h3 className="ppd-widget-pie-chart__title">{widget.name}</h3>

            <div className={`ppd-widget-pie-chart__graph-wrap ${labels.length > maxItems ? 'ppd-widget-pie-chart__graph-wrap--grow' : ''}`}>
                <PPDWidgetPieChartGraph
                    labels={labels}
                    values={amountValues}
                    colors={colors}
                    activeIndex={store.activeIndex}
                    mode={'outline'}
                    className="ppd-widget-pie-chart__graph"
                />
            </div>

            <PPDWidgetPieChartLegend
                className="ppd-widget-pie-chart__legend"
                labels={limitedLabels}
                values={limitedValues}
                colors={limitedColors}
                onHover={(i) => store.set('activeIndex', i)}
                onLeave={() => store.set('activeIndex', null)}
            />

            {(labels.length > maxItems) && (
                <button
                    className="ppd-widget-pie-chart__show-all"
                    onClick={() => store.set('isOpenModal', true)}
                >
                    Все группы
                </button>
            )}

            {store.isOpenModal && (
                <PPDWidgetPieChartModal
                    title={widget.name}
                    labels={labels}
                    values={values}
                    colors={colors}
                    isOpen={store.isOpenModal}
                    onClose={() => store.set('isOpenModal', false)}
                />
            )}
        </div>
    );
});

